import { createTheme, ThemeProvider } from "@mui/material";
import "../styles/globals.css";
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { GoogleAnalytics } from "nextjs-google-analytics";

const theme = createTheme({
  palette: {
    primary: {
      main: "#14213d",
    },
    secondary: {
      main: "#fbae18",
    },
  },
});

function MyApp({ Component, pageProps }) {
  return (
    <>
      <GoogleAnalytics trackPageViews />
      <ThemeProvider theme={theme}>
        <Component {...pageProps} />
      </ThemeProvider>
    </>
  );
}

export default MyApp;
